import React, { useState } from "react";

import { Switch, Route } from "react-router-dom";

import RevenueAccounts from "../../finance/_lists/RevenueAccounts";
import ProjectsIncomes from "../../finance/_lists/ProjectsIncomes";
import StudentFees from "../../finance/_lists/StudentFees";
import MiscIncomes from "../../finance/_lists/MiscIncomes";
import GrantsIncomes from "../../finance/_lists/Grants";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import { useEffect } from "react";

const Revenues = (props) => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles, setTableTitles] = useState({
    mainTitle: "عواید",
  });

  const {halfYearId} = props.match.params;


  useEffect(() => {
    const { tid } = props.match.params;

    switch (tid) {
      case "1":
        setTableTitles({ mainTitle: "فیس محصلین" });
        break;
      case "2":
        setTableTitles({ mainTitle: "پروژه ها" });
        break;
      case "3":
        setTableTitles({ mainTitle: "پژوهش" });
        break;
      case "4":
        setTableTitles({ mainTitle: "هدایا" });
        break;
      case "5":
        setTableTitles({ mainTitle: "درآمد های متفرقه" });
        break;
    }
  }, []);

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        printHeadTexts={printHeadTexts}
        title={tableTitles.mainTitle}
      />
      <PrintBodyTitle title={[]} />
      <div className="print-table-area">
        <Switch>
          <Route path="/print/revenues/1" render={() => <StudentFees halfYearId={halfYearId} />} />
          <Route path="/print/revenues/2" render={() => <ProjectsIncomes halfYearId={halfYearId} />} />
          <Route path="/print/revenues/3" render={() => <GrantsIncomes halfYearId={halfYearId} />} />
          <Route path="/print/revenues/4" render={() => <RevenueAccounts halfYearId={halfYearId} />} />
          <Route path="/print/revenues/5" render={() => <MiscIncomes halfYearId={halfYearId} />} />
        </Switch>
      </div>
    </main>
  );
};

export default Revenues;
